import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { createFrontendModule, TranslationBlueprint } from '@backstage/frontend-plugin-api';
import { apiDocsTranslationRef } from '@backstage/plugin-api-docs/alpha';

const apiDocsMessages = createTranslationMessages({
  ref: apiDocsTranslationRef,
  full: true,
  messages: {
    'apiDefinitionDialog.closeButtonTitle': 'Fechar',
    'apiDefinitionDialog.tabsAriaLabel': 'Opções de definição de API',
    'apiDefinitionDialog.toggleButtonAriaLabel': 'Alternar definição de API',
    'defaultApiExplorerPage.title': 'APIs',
    'defaultApiExplorerPage.subtitle': 'Explorar APIs de {{orgName}}',
    'defaultApiExplorerPage.pageTitleOverride': 'APIs',
    'defaultApiExplorerPage.createButtonTitle': 'Registrar API existente',
    'defaultApiExplorerPage.supportButtonTitle': 'Todas as suas APIs',
    'consumedApisCard.error.title': 'Não foi possível carregar APIs',
    'consumedApisCard.title': 'APIs consumidas',
    'consumedApisCard.emptyContent.title': 'Este(a) {{entity}} não consome nenhuma API.',
    'hasApisCard.error.title': 'Não foi possível carregar APIs',
    'hasApisCard.title': 'APIs',
    'hasApisCard.emptyContent.title': 'Este(a) {{entity}} não contém nenhuma API.',
    'providedApisCard.error.title': 'Não foi possível carregar APIs',
    'providedApisCard.title': 'APIs fornecidas',
    'providedApisCard.emptyContent.title': 'Este(a) {{entity}} não fornece nenhuma API.',
    'apiEntityColumns.typeTitle': 'Tipo',
    'apiEntityColumns.apiDefinitionTitle': 'Definição de API',
    'consumingComponentsCard.error.title': 'Não foi possível carregar componentes',
    'consumingComponentsCard.title': 'Consumidores',
    'consumingComponentsCard.emptyContent.title': 'Nenhum componente consome esta API.',
    'providingComponentsCard.error.title': 'Não foi possível carregar componentes',
    'providingComponentsCard.title': 'Fornecedores',
    'providingComponentsCard.emptyContent.title': 'Nenhum componente fornece esta API.',
    'apisCardHelpLinkTitle': 'Saiba como mudar isto',
  },
});


export const apiDocsTranslationModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [
    TranslationBlueprint.make({
      name: 'api-docs-overrides',
      params: {
        resource: apiDocsMessages
      },
    }),
  ]
})